import { Controller } from "@hotwired/stimulus"

// Controller for toggling custom tax exemption basis field visibility
// Usage:
//   data-controller="tax-settings" on the form
//   data-action="change->tax-settings#toggleCustomBasis" on the select
//   data-tax-settings-target="customBasis" on the custom basis container
//   data-tax-settings-target="customBasisInput" on the input field itself
export default class extends Controller {
  static targets = ["customBasis", "customBasisInput"]

  connect() {
    this.toggleCustomBasis()
  }

  toggleCustomBasis(event) {
    const select = event?.target || this.element.querySelector("select[name*='tax_exemption_type']")
    if (!select) return

    const isCustom = select.value === "custom"

    if (this.hasCustomBasisTarget) {
      this.customBasisTarget.classList.toggle("hidden", !isCustom)
    }

    // Clear custom basis input when switching away from "custom"
    if (!isCustom && this.hasCustomBasisInputTarget) {
      this.customBasisInputTarget.value = ""
    }
  }
}
